// utils/gtagIframe.js
let iframeInstance = null;
let hasInitialized = false;

export const initGtagIframe = (trackingId) => {
    if (hasInitialized && iframeInstance) {
        return iframeInstance;
    }

    const existing = document.getElementById('gtag-video-tracking-iframe');
    if (existing) {
        iframeInstance = existing;
        hasInitialized = true;
        return existing;
    }

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.id = 'gtag-video-tracking-iframe';
    
    document.body.appendChild(iframe);
    
    // Write immediately - don't wait for onload
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    
    iframeDoc.open();
    iframeDoc.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <script>
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                
                gtag('js', new Date());
                gtag('config', '${trackingId}', {
                    send_page_view: false
                });
                
                // Define function SYNCHRONOUSLY
                window.sendVideoPageView = function(pagePath, pageTitle, pageLocation) {
                    gtag('event', 'page_view', {
                        page_path: pagePath,
                        page_title: pageTitle,
                        page_location: pageLocation,
                        send_to: '${trackingId}'
                    });
                };
            </script>
            <script async src="https://www.googletagmanager.com/gtag/js?id=${trackingId}"></script>
        </head>
        <body></body>
        </html>
    `);
    iframeDoc.close();
    
    iframeInstance = iframe;
    hasInitialized = true;
    
    return iframe;
};

export const sendGtagPageView = (iframe, params = {}) => {
    if (!iframe || !iframe.contentWindow || !iframe.contentWindow.sendVideoPageView) {
        return;
    }

    const fullUrl = window.location.protocol + '//' + window.location.host + params.page_path;

    try {
        iframe.contentWindow.sendVideoPageView(params.page_path, params.page_title, fullUrl);
    } catch (e) {
        console.error('Error:', e);
    }
};

export const destroyGtagIframe = () => {
    if (iframeInstance && iframeInstance.parentNode) {
        iframeInstance.parentNode.removeChild(iframeInstance);
        iframeInstance = null;
        hasInitialized = false;
    }
};